import { GAME_WIDTH } from "../../data/constants"
import type { EnemyData, GameSprite } from "../../types"
import { type EnemyState, StatefulEnemyRuntime } from "../enemy-system"

export class ChainDrifterEnemy extends StatefulEnemyRuntime<"active"> {
  public constructor(sprite: GameSprite, enemyData: EnemyData) {
    const states: EnemyState<"active">[] = [
      {
        name: "active",
        behaviorState: "flying",
        animationState: "flying",
        update: (context) => {
          const { sprite, enemyData, time, scrollCompensation } = context
          const spec = context.enemyDef?.movementSpec
          if (spec?.action !== "sine") return null

          const homeY = enemyData.homeY ?? sprite.y
          if (spec.amplitude === 0) {
            sprite.y = homeY
          } else {
            const harmonic =
              Math.sin(time / (spec.divisor * 0.6)) * (spec.amplitude * 0.15)
            sprite.y =
              homeY + Math.sin(time / spec.divisor) * spec.amplitude + harmonic
          }

          if (spec.stopOffsetPx !== undefined) {
            const stopX =
              (enemyData.homeX ?? GAME_WIDTH + 40) - spec.stopOffsetPx
            if (sprite.x <= stopX) {
              sprite.x = stopX + Math.sin(time / 320) * 6
              enemyData.vx = scrollCompensation
            }
          }
          return null
        },
      },
    ]

    super(sprite, enemyData, "active", states)
  }
}
